import {
  Box,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Spinner,
  useDisclosure
} from '@chakra-ui/react'
import paginate from 'paginate-array'
import { FC, useMemo, useState } from 'react'
import Paginate from 'react-paginate'

import useParamsCenter from '@hook/config/use-params-center'

import ParamsCenterTableTr from './Tr'

const ParamsCenterTable: FC = () => {
  const { onOpen } = useDisclosure()
  const {
    paramsCenter,
    loading,
    getParamsCenter,
    paramsCenterQuery: fastQuery
  } = useParamsCenter()

  const [_selected, setSelected] = useState<any>()

  const [page, setPage] = useState(1)

  const pagination = useMemo(() => {
    let toSearch = paramsCenter

    if (fastQuery.length > 0) {
      const query = fastQuery.toLowerCase()

      toSearch = toSearch.filter((row: any) =>
        JSON.stringify(row).toLowerCase().includes(query)
      )
    }

    const arr = paginate(toSearch, page, 12)

    return arr
  }, [page, paramsCenter, fastQuery])

  const handleUserEdit = (paramsCenter: any) => {
    setSelected(paramsCenter)
    onOpen()
  }

  return (
    <Box px={0} py={6}>
      {loading ? (
        <Flex
          h="220px"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="lg" color="yellow.400" mb={4} />
          <Text maxW="420px" textAlign="center">
            Obtendo perfis... aguarde!
          </Text>
        </Flex>
      ) : (
        <>
          <Table variant="simple" size="sm" mb={8}>
            <Thead>
              <Tr>
                <Th>Codigo</Th>
                <Th>Nome</Th>
                <Th>Acao</Th>
              </Tr>
            </Thead>
            <Tbody>
              {pagination.data.map((paramsCenter: any, index: number) => (
                <ParamsCenterTableTr
                  key={`profile-${index}`}
                  data={paramsCenter}
                  onSelect={handleUserEdit}
                  onUpdate={getParamsCenter}
                />
              ))}
            </Tbody>
          </Table>

          {paramsCenter.length > 0 && (
            <Paginate
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageCount={pagination.totalPages}
              forcePage={pagination.currentPage - 1}
              pageRangeDisplayed={5}
              marginPagesDisplayed={1}
              previousLabel={'Página anterior'}
              nextLabel={'Próxima página'}
              onPageChange={({ selected }: any) => {
                setPage(selected + 1)
              }}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default ParamsCenterTable
